/* eslint-disable @typescript-eslint/member-ordering */
import { BreakpointObserver } from '@angular/cdk/layout';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  SecurityContext
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import {
  selectBrandLoaded,
  selectIsPartner
} from 'libs/shared/utility/brand/src/lib/+state/brand.selectors';
import { get as _get } from 'lodash';
import { combineLatest, firstValueFrom, Observable, Subject } from 'rxjs';
import {
  filter,
  first,
  map,
  switchMap,
  take,
  takeUntil,
  tap,
  withLatestFrom
} from 'rxjs/operators';

import { BillAccountsSelectors } from '@amfam/billing/billaccount/data-access';
import { env } from '@amfam/environment';
import {
  policiesQuery,
  PolicyDocumentsSelectors,
  PolicySelectors
} from '@amfam/policy/data-access';
import { PolicyUtilService } from '@amfam/policy/e-signature/data-access';
import { GoPaperLessSelectors } from '@amfam/policy/go-paperless/data-access';
import {
  AutoPolicy,
  NamedInsured,
  PolicyActions,
  PolicyAnalytics,
  PolicyDetails,
  PolicyDocument,
  PolicyRole,
  RiskSelectionContext,
  Vehicle,
  VehicleRole
} from '@amfam/policy/models';
import { VechiclePolicyChangeEntryPoint, VehicleFacade } from '@amfam/policy/vehicle/data-access';
import { AnalyticsFacade, PageAnalyticParams } from '@amfam/shared/analytics';
import {
  BillingPaymentPaths,
  ButtonProps,
  ClaimsNavigationPaths,
  Components,
  ComponentTheme,
  PolicyChangeRequestType,
  PolicyView,
  TypeOfPolicy
} from '@amfam/shared/models';
import { DocumentPipeService } from '@amfam/shared/ui/pipes';
import { QuickLink, QuickLinksService } from '@amfam/shared/ui/quick-links';
import { BrandSelectors } from '@amfam/shared/utility/brand';
import { FeatureFlagService } from '@amfam/shared/utility/feature-flag/data-access';
import {
  ImpersonateRolesService,
  impersonationQuery,
  ImpersonationRoles
} from '@amfam/shared/utility/impersonation';
import { fromRouterActions } from '@amfam/shared/utility/navigation';
import {
  CopyService,
  openWindowBlob,
  ScrollService,
  WindowRef
} from '@amfam/shared/utility/shared-services';
import { Action, DockingBarService, LoadingSpinnerService, PageTitleService } from '@amfam/ui-kit';

import * as fromRoot from '../../core/store';
import * as replaceVehicleActions from '../../core/store/replace-vehicle/replace-vehicle.actions';
import { SessionActivityService } from '../../login';
import { PolicyViewService } from '../services/policy-view.service';

@Component({
  selector: 'ds-plauto-large',
  templateUrl: './plauto-large.component.html',
  styleUrls: ['./plauto-large.component.scss', '../shared/policy-shared.scss'],
  standalone: false
})
export class PlautoLargeComponent implements OnInit, OnDestroy, AfterViewInit {
  private isAuthorized = false;
  private claimsFNOLEnabled: boolean;
  isConnectPartner = false;
  private componentName: any = {};

  // shared subject for all subscriptions
  private stop$: Subject<void> = new Subject<void>();

  // **** Start of Analytics data for this component
  private pageAnalytic: PageAnalyticParams = {
    pageName: '',
    experience: '',
    primaryCategory: 'My Account',
    subCategory1: 'Policies',
    subCategory2: '',
    subCategory3: ''
  };
  // **** End of Analytics data for this component

  policy: AutoPolicy = null;
  selectedVehicle: Vehicle;
  isEnrolledGoPaperless: boolean;
  openGeneral = false;
  openCoverage = false;
  openDiscounts = false;
  openDocuments = false;
  selectedVehicleId: string;
  multipleVehicle = false;
  policyDocuments: Observable<PolicyDocument[]>;

  vehicle: Subject<any> = new Subject<any>();
  componentData: any;
  quickLinksOverride = new Array<QuickLink>();
  showNewBadge = false;

  premiumActionButtons: ButtonProps[];
  peopleCoveredActionButtons: ButtonProps[];
  coverageActionButtons: ButtonProps[];
  nameInsured: string;
  nameInsuredHeading: string;
  listedDrivers: string;
  listedDriversHeading: string;
  nonDrivers: string;
  jumpLinks: ButtonProps[];
  newTemplate = false;
  isFutureDatedPolicy = false;
  hasCancelDate: boolean;

  public isAdvanceAutoPolicy$: Observable<boolean>;
  public hasCompAndCollisonCoverage$: Observable<boolean>;
  public isImpersonating$ = this.store.select(impersonationQuery.isImpersonating);
  changeCoverageEnabled$ = this.store
    .select(BrandSelectors.selectIsPartner)
    .pipe(
      map(isPartner =>
        isPartner
          ? this.featureFlagService.isEnabled('partner_model_coverage')
          : this.featureFlagService.isEnabled('model_coverage')
      )
    );
  private isSmallScreen = false;
  showCoveragesCard = true;
  /* Shared Components */
  showPolicyView = false;
  policyView: PolicyView;
  vehicleId: string;
  policyNumber: string;
  theme: ComponentTheme;
  sessionHandler;

  public get inWebview(): boolean {
    return (
      this.router.url.includes('webview') && this.featureFlagService.isEnabled('policyview_webview')
    );
  }

  public get isPolicyViewEnabled(): boolean {
    return this.feature.isEnabled('policy_view');
  }

  constructor(
    private route: ActivatedRoute,
    public spinner: LoadingSpinnerService,
    private win: WindowRef,
    private copyService: CopyService,
    private pageTitle: PageTitleService,
    private dockingBarService: DockingBarService,
    private impersonateRolesService: ImpersonateRolesService,
    private store: Store<fromRoot.RootState>,
    private feature: FeatureFlagService,
    private quickLinksService: QuickLinksService,
    private cdr: ChangeDetectorRef,
    private documentPipeService: DocumentPipeService,
    private sanitizer: DomSanitizer,
    private policyUtilService: PolicyUtilService,
    private analyticsFacade: AnalyticsFacade,
    private router: Router,
    private scrollService: ScrollService,
    private breakpointObserver: BreakpointObserver,
    private featureFlagService: FeatureFlagService,
    private policyViewService: PolicyViewService,
    private vehicleFacade: VehicleFacade,
    private sessionActivityService: SessionActivityService
  ) {
    this.componentName.policy = 'policy';
    this.componentData = this.copyService.getComponentData('policyDetail');
  }

  async ngOnInit() {
    this.route.queryParamMap
      .pipe(
        takeUntil(this.stop$),
        tap(async () => {
          await this.intialize();
        })
      )
      .subscribe();
  }

  async intialize() {
    this.pageTitle.set('Policy Details');
    const policyNumber = this.getPolicyNumber();
    this.showPolicyView = await this.policyViewService.showSharedComponent(
      policyNumber,
      TypeOfPolicy.Auto,
      Components.PolicyView
    );
    if (this.isPolicyViewEnabled && this.showPolicyView) this.buildPolicyView();
    else {
      this.newTemplate = this.feature.isEnabled('policy_new_template');
      this.screenSize();
      this.setUpDockingBar();
      this.route.queryParams.subscribe(params => {
        const scrollToElementId = params['scrollTo'];
        if (scrollToElementId) {
          setTimeout(() => {
            const isSmallScreen = this.breakpointObserver.isMatched(
              '(max-width: 480px) and (orientation: portrait)'
            );
            if (isSmallScreen) this.scrollService.scrollToElement('documentsCard', 85);
            else this.scrollService.scrollToElement('documentsCard', 205);
          }, 0);
        }
      });

      this.route.params.pipe(takeUntil(this.stop$)).subscribe(() => {
        this.policyUtilService.dispatchPolicySelectedAction(this.route.params);
      });

      this.isAdvanceAutoPolicy$ = this.store.select(PolicySelectors.selectSelectedPolicy).pipe(
        filter(selectedPolicy => !!selectedPolicy),
        map(selectedPolicy => {
          const data = {
            policynumber: selectedPolicy.policyNumber,
            inEligibleStates: this.featureFlagService.isEnabled('kyd_model_coverage')
              ? []
              : env.modelCoverageDisabledStates || []
          };
          return data;
        }),
        switchMap(data => this.store.select(fromRoot.isMCEligibleStateAdvanceAutoPolicy, data)),
        take(1)
      );

      /**
       * @description: Once the user clicks on a vehicle from the header navigation, this.vehicle observable
       * would have a value and emit. We take the selected vehicle and the policy.
       */
      combineLatest([
        this.vehicle.asObservable(),
        this.store.select(PolicySelectors.selectSelectedPolicy)
      ])
        .pipe(
          map(([vehicleId, policy]) => ({
            policy: policy as AutoPolicy,
            vehicleId: vehicleId
          }))
        )
        .pipe(
          takeUntil(this.stop$),
          filter(
            state =>
              !!state.policy &&
              (this.selectedVehicleId
                ? state.policy.vehicles.findIndex(
                    vehicle => vehicle.vehicleId === this.selectedVehicleId
                  ) !== -1
                : true)
          ),
          tap(state => {
            this.policy = state.policy as AutoPolicy;
            if (this.policy && !this.selectedVehicleId) {
              this.selectedVehicle = this.policy.vehicles[0];
              this.selectedVehicleId = this.selectedVehicle.vehicleId;
            }
            this.isFutureDatedPolicy =
              this.policy.periodStartDate.getTime() >= new Date().getTime() ? true : false;
            this.hasCancelDate = !!this.policy.cancelDate;
            this.showNewBadge = false;
            this.policyDocuments = this.store.pipe(
              select(PolicyDocumentsSelectors.selectPolicyDocuments),
              map(documents =>
                documents.filter(policyDocument => {
                  if (
                    policyDocument.isNew &&
                    policyDocument.policyNumber === this.policy.policyNumber
                  ) {
                    this.showNewBadge = true;
                  }
                  return policyDocument.policyNumber === this.policy.policyNumber;
                })
              )
            );
            if (state.vehicleId) {
              this.selectedVehicleId = state.vehicleId;
              if (state.policy)
                this.selectedVehicle = state.policy.vehicles.find(
                  vehicle => vehicle.vehicleId === state.vehicleId
                );
            }
            this.multipleVehicle = _get(this.policy, 'vehicles.length', 0) > 1;
            this.loadAnalytics();
            this.setPeopleCovered();
            this.setUpActionButtons();
            this.setupJumpLinks();
          })
        )
        .subscribe();

      this.route.queryParamMap.pipe(takeUntil(this.stop$)).subscribe(queryParams => {
        this.showCoveragesCard = true;

        if (queryParams.has('openAccordion')) {
          this.openGeneral = false;
          this.openCoverage = false;
          this.openDiscounts = false;
          this.openDocuments = false;
          switch (queryParams.get('openAccordion')) {
            case 'general':
              this.openGeneral = true;
              break;
            case 'coverage':
              this.openCoverage = true;
              break;
            case 'discounts':
              this.openDiscounts = true;
              break;
            case 'documents':
              this.openDocuments = true;
              break;
          }
        }
        if (queryParams.has('vehicleId')) {
          this.selectedVehicleId = queryParams.get('vehicleId');
          // Once we have the vehicle id we update the vehic;e subject to propagate the value.
          this.vehicle.next(this.selectedVehicleId);

          const vehicles: Vehicle[] = _get(this.policy, 'vehicles', []);
          this.selectedVehicle = vehicles.find(v => v.vehicleId === this.selectedVehicleId);

          this.setUpDockingBar();
        } else this.vehicle.next(null);
      });

      this.store
        .select(BrandSelectors.selectIsPartner)
        .pipe(takeUntil(this.stop$))
        .subscribe(isPartner => {
          this.isConnectPartner = isPartner;
        });

      this.store
        .select(PolicySelectors.selectLatestPolicyError)
        .pipe(
          takeUntil(this.stop$),
          filter(error => !!error)
        )
        .subscribe(error => {
          this.analyticsFacade.trackPageAndError(this.pageAnalytic, 'PolicyLoadError');
          throw error;
        });

      // Subscribe to get the Go Paperless Status
      this.store
        .select(GoPaperLessSelectors.selectIsEnrolledGoPaperless)
        .pipe(takeUntil(this.stop$))
        .subscribe(isEnrolled => {
          this.isEnrolledGoPaperless = isEnrolled;
        });

      this.impersonateRolesService
        .isAuthorized(ImpersonationRoles.REPORT_CLAIM_VIEW)
        .pipe(takeUntil(this.stop$))
        .subscribe(result => {
          this.isAuthorized = result;
          this.setUpDockingBar();
        });
      this.hasCompAndCollisonCoverage$ = this.store
        .select(PolicySelectors.selectSelectedPolicy)
        .pipe(
          filter(policy => !!policy),
          switchMap(() =>
            this.store.select(
              fromRoot.hasSinglePolicyCompAndCollisonCoverageAndCarLightTruck,
              this.selectedVehicleId
            )
          ),
          first()
        );
      this.updateCoverageButtonVisibility();
      this.quickLinksOverride = this.quickLinksService.buildQuickLinks();
      this.spinner.stop();
    }
  }

  private getPolicyNumber() {
    return this.route.snapshot.paramMap.get('id');
  }

  private async buildPolicyView() {
    if (!this.inWebview) this.setUpDockingBar();
    this.loadAnalytics();
    try {
      this.vehicleId = this.route.snapshot.queryParamMap.get('vehicleId');
      this.policyNumber = this.route.snapshot.paramMap.get('id');
      this.policyView = await this.policyViewService.buildPolicyView(
        this.policyNumber,
        this.vehicleId,
        TypeOfPolicy.Auto
      );
      this.keepSessionAlive();
    } catch (error) {}
  }

  //@HostListener('window:resize')
  resize() {
    this.screenSize();

    this.setUpDockingBar();
  }
  screenSize() {
    this.isSmallScreen = this.breakpointObserver.isMatched(
      '(max-width: 960px) and (orientation: portrait)'
    );
  }
  private updateCoverageButtonVisibility(): void {
    combineLatest([
      this.isAdvanceAutoPolicy$,
      this.hasCompAndCollisonCoverage$,
      this.isImpersonating$,
      this.changeCoverageEnabled$
    ])
      .pipe(
        map(
          ([
            isAdvanceAutoPolicy,
            hasCompAndCollisonCoverage,
            isImpersonating,
            changeCoverageEnabled
          ]) => {
            return (
              isAdvanceAutoPolicy &&
              hasCompAndCollisonCoverage &&
              !isImpersonating &&
              changeCoverageEnabled
            );
          }
        ),
        takeUntil(this.stop$)
      )
      .subscribe(showButton => {
        if (showButton) {
          // Button Logic for Advanced
          this.coverageActionButtons = [
            {
              name: 'Edit Coverage Amounts',
              iconClass: 'icon-pen',
              clickEvent: () => {
                this.analyticsFacade.trackButtonClick(
                  PolicyDetails.buttonCoverageDetailsUpdateMyCoverage
                );
                this.store.dispatch(
                  fromRouterActions.Go({
                    path: ['/policies/change-coverage/' + this.selectedVehicleId + '/get-quote']
                  })
                );
              }
            }
          ];
        } else {
          //Button logic for classic
          this.coverageActionButtons = [
            {
              name: 'Request a Policy Update',
              iconClass: 'icon-refresh-reset',
              clickEvent: () => {
                this.analyticsFacade.trackButtonClick(PolicyDetails.buttonRequestPolicyChange);
                this.router.navigate(['/policies/changerequest'], {
                  state: { changeRequestType: PolicyChangeRequestType.POLICY_COVERAGE_CHANGE }
                });
              }
            }
          ];
        }
      });
  }

  ngAfterViewInit() {
    // Don't show slider until the slide content has finished loading
    // otherwise the slider will get stuck between slides as it doesn't calc the slide widths correctly
    this.cdr.detectChanges(); // Prevents changedafterchecked error
    // if (this.newTemplate && this.openDocuments) {
    //   this.waitForElement('#documentsCard', element => {
    //     this.scrollService.scrollToElement('documentsCard', 85);
    //   });
    // }
  }

  onCoverageDetailsClicked() {
    this.analyticsFacade.trackButtonClick(PolicyDetails.jumpLinkCoverage);
    if (this.isSmallScreen) this.scrollService.scrollToElement('coveragesCard', 85);
    else this.scrollService.scrollToElement('coveragesCard', 215);
  }

  private setPeopleCovered() {
    const pni = this.getNameFromPolicyRoles(PolicyRole.PRIMARYNAMEDINSURED);
    const sni = this.getNameFromPolicyRoles(PolicyRole.SECONDARYNAMEDINSURED);
    if (pni || sni) {
      const nameInsured = `${pni?.name}${sni?.name ? `, ${sni.name}` : ''}`;
      if (nameInsured) {
        this.nameInsured = nameInsured;
        this.nameInsuredHeading = `Named Insured${this.nameInsured?.includes(',') ? '(s)' : ''}`;
      }
    }
    this.listedDrivers = this.getNameFromVehicleRoles();
    this.listedDriversHeading = `Listed Driver${this.listedDrivers?.includes(',') ? '(s)' : ''}`;
  }

  private getNameFromPolicyRoles(key: string): NamedInsured {
    if (!key || !this.policy) return null;
    const roles = this.policy.policyRoles;
    const role = roles?.find(role => role.roleType.toLowerCase() === key.toLowerCase());
    return role;
  }

  private getNameFromVehicleRoles() {
    if (this.selectedVehicle) {
      const roles = this.selectedVehicle.vehicleRoles;
      return roles
        .filter(role =>
          [
            VehicleRole.ADDITIONALDRIVER.toLowerCase(),
            VehicleRole.PRIMARYDRIVER.toLowerCase(),
            VehicleRole.DRIVER.toLocaleLowerCase()
          ].includes(role.roleType.toLowerCase())
        )
        .map(role => role.name)
        .join(', ');
    }
    return null;
  }

  private setUpActionButtons() {
    combineLatest([
      this.store.select(BillAccountsSelectors.selectAllBillAccountsNotifications),
      this.store.select(BillAccountsSelectors.selectBillAccountsAnyLoading)
    ])
      .pipe(
        filter(([_, loading]) => !loading),
        takeUntil(this.stop$),
        tap(([billAccounts, _]) => {
          if (billAccounts) {
            const match = billAccounts.find(billAccount => {
              return billAccount.billAccountNumber === this.policy.billingAccountNumber;
            });
            if (match && match.detailsLoaded) {
              this.premiumActionButtons = [
                {
                  name: 'Manage Billing Account',
                  iconClass: 'icon-online-billing',
                  clickEvent: () => {
                    this.analyticsFacade.trackButtonClick(PolicyDetails.buttonManageBillingAccount);
                    this.router.navigate([
                      BillingPaymentPaths.BILLING_DETAIL_PAGE,
                      this.policy.billingAccountNumber
                    ]);
                  }
                }
              ];
            } else this.premiumActionButtons = [];
          }
        })
      )
      .subscribe();
    this.peopleCoveredActionButtons = [
      {
        name: 'Request a Policy Update',
        iconClass: 'icon-refresh-reset',
        clickEvent: () => this.goToRequestPolicyUpdate()
      }
    ];
  }

  private setupJumpLinks() {
    this.jumpLinks = [
      {
        iconClass: 'icon-online-billing',
        clickEvent: () => {
          this.scrollService.scrollToElement('premiumCard', 85);
          this.analyticsFacade.trackButtonClick(PolicyDetails.jumpLinkPremium);
        },
        name: 'Premium'
      },
      {
        iconUrl: 'jump-link-coverage.svg',
        clickEvent: () => {
          this.scrollService.scrollToElement('coveragesCard', 85);
          this.analyticsFacade.trackButtonClick(PolicyDetails.jumpLinkCoverage);
        },
        name: 'Coverage'
      },
      {
        iconClass: 'icon-documents',
        clickEvent: () => {
          this.scrollService.scrollToElement('documentsCard', 85);
          this.analyticsFacade.trackButtonClick(PolicyDetails.jumpLinkPolicyDetailsDocuments);
        },
        name: 'Documents'
      }
    ];
    if (!this.showCoveragesCard)
      this.jumpLinks = this.jumpLinks.filter(jl => jl.name !== 'Coverage');
  }

  onPageChanged(currentPage: number) {
    if (this.policy && currentPage < this.policy.vehicles.length && currentPage >= 0) {
      this.selectedVehicle = this.policy.vehicles[currentPage];
    } else {
      this.selectedVehicle = null;
    }
  }

  loadAnalytics() {
    this.pageAnalytic.pageName = 'MyAccount:Policies:PolicyDetails';
    this.analyticsFacade.trackEvent({
      event: 'policy_details_review',
      product_line: 'auto'
    });
    this.analyticsFacade.trackPage(this.pageAnalytic);
  }

  setUpDockingBar() {
    if (this.isSmallScreen) {
      this.dockingBarService.hide();
    } else {
      this.setupDockingBarContents();
    }
  }
  setupDockingBarContents() {
    this.dockingBarService.clear();

    // Check FNOL feature is enabled.
    this.claimsFNOLEnabled =
      this.feature.isEnabled('fnol') &&
      (!this.isConnectPartner || this.feature.isEnabled('partner_dynamic_fnol'));

    /* Set up the action buttons */
    const reportClaimAction: Action = new Action('File a Claim', () => this.goToFileaAclaim());
    this.dockingBarService.registerHeading('Policy Details');
    if (this.isAuthorized) {
      this.dockingBarService.registerAction(reportClaimAction);
    }

    if (this.policy) {
      const insuranceCardAction = new Action('Get Insurance Card', () => {
        this.analyticsFacade.trackButtonClick(PolicyAnalytics.buttonPoliciesGetPOI);
        this.router.navigateByUrl('/insurance-card/' + this.selectedVehicleId);
      });
      this.dockingBarService.registerAction(insuranceCardAction);
    }
  }

  openDocumentOnAndroid() {
    let windowRef;
    if (!window.navigator) {
      windowRef = this.win.nativeWindow.open();
    }
    this.documentPipeService
      .retrieveDocument(this.policy.poiLink)
      .pipe(take(1))
      .subscribe(
        res => {
          if (!res) {
            if (windowRef) {
              windowRef.close();
            }
            this.analyticsFacade.trackPage(PolicyAnalytics.pagePoliciesGetPOIError);
          }

          const url = this.sanitizer.sanitize(SecurityContext.URL, res);
          this.spinner.stop();
          openWindowBlob(this.win, url, res, windowRef, 'document.pdf');
        },
        () => {
          if (windowRef) {
            windowRef.close();
          }
        }
      );
  }

  openDocument() {
    let windowRef;
    windowRef = this.win.nativeWindow.open();
    this.documentPipeService
      .retrieveDocument(this.policy.poiLink)
      .pipe(take(1))
      .subscribe(
        res => {
          if (!res) {
            if (windowRef) {
              windowRef.close();
            }
            this.analyticsFacade.trackPage(PolicyAnalytics.pagePoliciesGetPOIError);
          }

          const url = this.sanitizer.sanitize(SecurityContext.URL, res);
          this.spinner.stop();
          windowRef.location.href = url;
        },
        () => {
          if (windowRef) {
            windowRef.close();
          }
        }
      );
  }

  showCoverages(show) {
    this.showCoveragesCard = show;
    this.setupJumpLinks();
  }

  ngOnDestroy() {
    if (this.sessionHandler) this.sessionHandler();
    this.stop$.next();
    this.stop$.complete();
    this.dockingBarService.clear();
  }

  gotodocuments(elementRef: ElementRef) {
    if (elementRef) {
      const shadowRoot = elementRef.nativeElement.shadowRoot;
      if (shadowRoot) {
        const targetElement = shadowRoot.querySelector(
          'embedded-modules-policy-view-documents-card'
        );
        if (targetElement) {
          const isSmallScreen = this.breakpointObserver.isMatched(
            '(max-width: 960px) and (orientation: portrait)'
          );
          if (isSmallScreen) this.scrollService.scrollIntoView(targetElement, 85);
          else this.scrollService.scrollIntoView(targetElement, 215);
        }
      }
    }
  }

  goToRequestPolicyUpdate() {
    this.analyticsFacade.trackButtonClick(PolicyDetails.buttonRequestPolicyChange);
    this.router.navigate(['/policies/changerequest'], {
      state: { changeRequestType: PolicyChangeRequestType.POLICY_COVERAGE_CHANGE }
    });
  }

  goToFileaAclaim() {
    this.store
      .select(selectBrandLoaded)
      .pipe(
        filter(Boolean),
        withLatestFrom(this.store.select(selectIsPartner)),
        first(),
        tap(([, isPartner]) => {
          const claimsFNOLEnabled =
            this.feature.isEnabled('fnol') &&
            (!isPartner || this.feature.isEnabled('partner_dynamic_fnol'));
          if (claimsFNOLEnabled) {
            this.store.dispatch(
              fromRouterActions.Go({
                path: [ClaimsNavigationPaths.CLAIM_REPORTFNOL_HOME_PATH]
              })
            );
          } else {
            this.store.dispatch(
              fromRouterActions.Go({
                path: [ClaimsNavigationPaths.CLAIM_REPORT_HOME_PATH]
              })
            );
          }
        })
      )
      .subscribe();
  }

  goToInsuranceCard() {
    this.analyticsFacade.trackButtonClick(PolicyAnalytics.buttonPoliciesGetPOI);
    this.router.navigateByUrl('/insurance-card/' + this.vehicleId);
  }

  goToChangeCoverage() {
    this.analyticsFacade.trackButtonClick(PolicyDetails.buttonCoverageDetailsUpdateMyCoverage);
    this.store.dispatch(
      fromRouterActions.Go({
        path: ['/policies/change-coverage/' + this.vehicleId + '/get-quote']
      })
    );
  }

  async addReplaceVehicle() {
    const isPartner = await firstValueFrom(this.store.select(BrandSelectors.selectIsPartner));

    if (!isPartner) {
      this.analyticsFacade.trackButtonClick(PolicyDetails.buttonAddReplaceVehicle);
      this.vehicleFacade.setVehiclePolicyChangeEntryPoint(VechiclePolicyChangeEntryPoint.POLICY);
      this.store.dispatch(
        new replaceVehicleActions.SetVehicleRiskSelectionContext(
          RiskSelectionContext.REPLACE_VEHICLE
        )
      );

      const hasMultipleAdvanceAutoPolicies = await firstValueFrom(
        this.store.select(policiesQuery.selectHasMultipleAdvanceAutoPolicies)
      );

      // if multiple autoPolicies, route to risk-selection page
      if (hasMultipleAdvanceAutoPolicies) {
        return this.store.dispatch(
          fromRouterActions.Go({
            path: ['/policies/risk-selection']
          })
        );
      }

      combineLatest([
        this.store.select(fromRoot.hasAnyPolicyCompAndCollisonCoverageAndCarLightTruck),
        this.store.select(fromRoot.isValidVehicleToBeReplaced(this.vehicleId)),
        this.store.select(BrandSelectors.selectIsPartner),
        this.store.select(PolicySelectors.selectHasClassicPolicies),
        this.store.select(PolicySelectors.selectHasAdvancePolicies),
        this.store.select(PolicySelectors.selectHasOnlyPolicyComprehensiveCoverage),
        this.store.select(fromRoot.hasAnyPolicyLiabilityCoverage)
      ])
        .pipe(
          map(
            ([
              isEligibleForAddVehicleFlow,
              isValidVehicleToBeReplaced,
              isPartner,
              hasClassicPolicy,
              advancePolicy,
              hasOnlyPolicyComprehensiveCoverage,
              hasAnyPolicyLiabilityCoverage
            ]) => ({
              isEligibleForAddVehicleFlow,
              isValidVehicleToBeReplaced,
              isPartner,
              hasClassicPolicy,
              advancePolicy,
              hasOnlyPolicyComprehensiveCoverage,
              hasAnyPolicyLiabilityCoverage
            })
          ),
          take(1)
        )
        .subscribe(
          ({
            isEligibleForAddVehicleFlow,
            isValidVehicleToBeReplaced,
            isPartner,
            hasClassicPolicy,
            advancePolicy,
            hasOnlyPolicyComprehensiveCoverage,
            hasAnyPolicyLiabilityCoverage
          }) => {
            let route = [];
            const addVehicleSkipHardstop = this.featureFlagService.isEnabled(
              'add_vehicle_skip_hardstop'
            );
            const isShowhardstopRiskSelectionPage =
              this.featureFlagService.isEnabled('add_vehicle') &&
              addVehicleSkipHardstop &&
              ((hasClassicPolicy && !advancePolicy && !isPartner) ||
                (advancePolicy && !isPartner && hasOnlyPolicyComprehensiveCoverage) ||
                hasAnyPolicyLiabilityCoverage);
            if (
              isValidVehicleToBeReplaced ||
              (this.featureFlagService.isEnabled('add_vehicle') && !!isEligibleForAddVehicleFlow) ||
              isShowhardstopRiskSelectionPage
            ) {
              route = ['/policies/risk-selection'];
            } else {
              route = ['/policies/risk-selection', 'grace-period'];
            }

            this.store.dispatch(
              fromRouterActions.Go({
                path: route
              })
            );
          }
        );
    } else {
      this.vehicleFacade.setVehiclePolicyChangeEntryPoint(VechiclePolicyChangeEntryPoint.POLICY);
      combineLatest([
        this.store.select(fromRoot.hasAnyPolicyCompAndCollisonCoverageAndCarLightTruck),
        // TODO: this will be removed when partners and non-partners
        this.store.select(BrandSelectors.selectIsPartner)
      ])
        .pipe(
          map(([isEligibleForAddVehicleFlow, isPartner]) => ({
            isEligibleForAddVehicleFlow,
            isPartner
          })),
          take(1)
        )
        .subscribe(({ isEligibleForAddVehicleFlow, isPartner }) => {
          let addVehicleRoute;

          if (
            isPartner &&
            this.featureFlagService.isEnabled('add_vehicle') &&
            isEligibleForAddVehicleFlow
          ) {
            addVehicleRoute = ['/policies/add-vehicle', 'expectation'];
          } else if (
            this.featureFlagService.isEnabled('add_vehicle') &&
            isEligibleForAddVehicleFlow
          ) {
            addVehicleRoute = ['/policies/risk-selection'];
          } else if (isPartner) {
            addVehicleRoute = ['/policies/add-vehicle/agent-help'];
          } else {
            addVehicleRoute = ['/policies/risk-selection', 'grace-period'];
          }

          this.store.dispatch(
            fromRouterActions.Go({
              path: addVehicleRoute
            })
          );
        });
    }
  }

  async onAction(e) {
    console.log('on action', e);
    const event = e.event;
    const elementRef = e.elementRef;
    const action = event?.detail?.id || event?.detail?.name;

    if (this.inWebview && String(action).toUpperCase() !== PolicyActions.GETDOCUMENTS) {
      let eventInfo = event?.detail;
      if (eventInfo) {
        eventInfo = { ...eventInfo, policyNumber: this.policyNumber, vehicleId: this.vehicleId };
      }
      this.policyViewService.sendToApp(eventInfo);
      return;
    }

    switch (String(action).toUpperCase()) {
      case PolicyActions.REQUESTAPOLICYUPDATE:
        this.goToRequestPolicyUpdate();
        break;

      case PolicyActions.ADDREPLACEVEHICLE:
        await this.addReplaceVehicle();
        break;

      case PolicyActions.ADDREPLACEDRIVER:
        break;

      case PolicyActions.EDITCOVERAGEAMOUNTS:
        this.goToChangeCoverage();
        break;

      case PolicyActions.FILECLAIM:
        this.goToFileaAclaim();
        break;

      case PolicyActions.GETDOCUMENTS:
        this.gotodocuments(elementRef);
        break;

      case PolicyActions.GETINSURANCECARD:
        this.goToInsuranceCard();
        break;

      default:
        break;
    }
  }

  keepSessionAlive() {
    if (this.inWebview)
      this.sessionHandler = setInterval(() => {
        console.log('Auto - keep session!');
        this.sessionActivityService.registerUserActivity();
      }, 60000);
  }
}
